import store from '@/store'

export default {
  getCurrencyList() {
    return store.getters['Common/getCurrencyListFromState']
  },
  findCurrencyName(name) {
    const list = this.getCurrencyList()
    return list.find((ele) => ele.name === name)
  },
  findCurrencyNameById(id) {
    const list = this.getCurrencyList()
    return list.find((ele) => ele.currencyId === id)
  },

  setCurrencyInfo(list) {
    return list
      ? { label: list.name, value: list.currencyId }
      : { label: '-', value: null }
  },
  getCurrencyNameInfo(name) {
    const list = this.findCurrencyName(name)
    return this.setCurrencyInfo(list)
  },
  getCurrencyIdInfo(id) {
    const list = this.findCurrencyNameById(id)
    return this.setCurrencyInfo(list)
  },

  getCurrencyInfo() {
    const list = this.getCurrencyList()
    return list
      ? list.map((ele) => {
          return { label: ele.name, value: ele.currencyId }
        })
      : { label: '', value: 0 }
  },

  getJpCurrencySelectBoxInfo() {
    const jp = '日本円'
    return this.getCurrencyNameInfo(jp)
  },

  getCurrencyUnitName(id) {
    const list = this.getCurrencyList()
    const target = list.find((ele) => ele.currencyId === id)
    return target ? target.unitName : ''
  }
}
